var viewer_figure_default = {
  "figure": "_0Oh4W"
};
export {
  viewer_figure_default as default
};
//# sourceMappingURL=viewer-figure-scss.js.map
